'use client';

import { type FC, useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { currentVehicleIdAtom } from '@core/Atoms/Vehicle/CurrentVehicleId.atom';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { addRecentlyViewed } from '@page-builder/Components/RecentlyViewed/AddRecentlyViewed';

type Props = {
  vehicle: Vehicle;
};

export const PdpLogic: FC<Props> = ({ vehicle }) => {
  const setCurrentVehicle = useSetAtom(currentVehicleAtom);
  const setCurrentVehicleId = useSetAtom(currentVehicleIdAtom);

  useEffect(() => {
    setCurrentVehicle(vehicle);
    setCurrentVehicleId(vehicle?.heycarId);

    addRecentlyViewed(vehicle?.heycarId);
  }, [vehicle]);

  return null;
};

PdpLogic.displayName = 'PdpLogic';
